import { getResponseMessage } from "../../../utils";
import { ENDPOINTS } from "../../apiConfig";
import { showToast } from "../../../components";
import axiosRequest from "../universal/axiosService";
// export const fetchLatestUiid = async (type) => {
//   try {
//     const token = localStorage.getItem("token");
//     const response = await axios.get(ENDPOINTS.COUNTER.GETID, {
//       params: {
//         coll: "Counter",
//         fil: JSON.stringify({
//           table: { type: "NONE", value: type },
//         }),
//         ret: "count table",
//       },
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//       withCredentials: true,
//     });
//     //console.log("UIID Response:", response.data); // Add logging
//     return response.data;
//   } catch (error) {
//     //console.error("Error fetching latest UIID:", error);
//     showToast("Error fetching latest UIID", "error", 5000);
//     throw error;
//   }
// };

export const fetchLatestUiid = async (type) => {
  return await axiosRequest({
    method: "get",
    url: ENDPOINTS.COUNTER.GETID,
    params: {
      coll: "Counter",
      fil: JSON.stringify({
        table: { type: "NONE", value: type },
      }),
      ret: "count table",
    },
  });
};
